import useStory from './useStory';
import { Explainer } from './GuideParts';

// GUIDE 2'S ANIMATION (Oct 2026): one 1.5 ton AC, two rooms, two electricity
// meters counting units through the hours of use. The bedroom at night turns
// slowly; the top-floor room on a hot afternoon spins fast. Units come from
// the room model (twoMeters() in data/guideUnits.js). Plays once in view,
// rests fully drawn, Replay.

const fmt1 = (n) => (n < 10 ? n.toFixed(1) : String(Math.round(n)));

function Meter({ m, t, turns }) {
  const angle = turns * 360 * t;
  const hour = Math.min(m.hours, Math.floor(m.hours * t));
  return (
    <div className="grid content-start justify-items-center gap-2 rounded-xl border border-gray-200 p-3 text-center">
      <p className="text-[15px] font-extrabold leading-tight text-gray-900">{m.label}</p>
      <p className="-mt-1 text-[12px] leading-snug text-gray-500">{m.note}</p>
      <svg viewBox="0 0 120 120" width="120" height="120" aria-hidden="true" className="block">
        <rect x="6" y="6" width="108" height="108" rx="16" fill="#f9fafb" stroke="#d1d5db" />
        <rect x="24" y="18" width="72" height="22" rx="4" fill="#111827" />
        <text x="60" y="34" textAnchor="middle" fontSize="14" fontWeight="800" fill="#f9fafb" fontFamily="ui-monospace, monospace">
          {fmt1(m.units * t).padStart(4, ' ')}
        </text>
        <ellipse cx="60" cy="80" rx="34" ry="12" fill="#e5e7eb" stroke="#9ca3af" />
        <g transform={`translate(60 80) scale(1 0.35) rotate(${angle % 360})`}>
          <line x1="0" y1="0" x2="34" y2="0" stroke="#dc2626" strokeWidth="6" strokeLinecap="round" />
        </g>
        <circle cx="60" cy="80" r="3" fill="#4b5563" />
      </svg>
      <p className="text-[14px] text-gray-600"><b className="text-[20px] font-extrabold tabular-nums text-gray-900">{fmt1(m.units * t)}</b> units</p>
      <p className="text-[13px] text-gray-500">Hour {Math.max(1, hour)} of {m.hours}</p>
    </div>
  );
}

export default function TwoMeters({ meters, watch, sources }) {
  const story = useStory(20000);
  // The disc turns in step with the units an hour: the slow room a few
  // turns, the fast room many more.
  const base = 6 / Math.min(...meters.map((m) => m.perHour));
  return (
    <Explainer title={watch.title} captions={watch.captions} story={story} note={watch.note} noteSrc={watch.noteSrc} sources={sources}>
      <div className="grid grid-cols-2 gap-2.5">
        {meters.map((m) => <Meter key={m.key} m={m} t={story.t} turns={base * m.perHour} />)}
      </div>
    </Explainer>
  );
}
